<template lang="pug">
  .main-container
    //platforms-tabs(:active="platform", @click:active="platform = $event")
    b-tabs.scrollable-area.overflow-x(nav-class="platform-tabs-flex", small)
      b-tab(v-for="flow in recentFlows", :key="flow.flow_id", :active="flow.flow_id == $route.params.flow_id", @click="$router.push({name: 'Flow builder', params: { flow_id: flow.flow_id } })")
        template(slot="title")
          span {{flow.name || 'Flujo ID: ' + flow.flow_id}}
          x-icon.hover-danger.icon-sm.ml-2(v-if="flow.flow_id != $route.params.flow_id", @click.stop="$store.commit('flow/removeRecentFlows', flow)")
    #conectorModal .
    .flow-builder-body
      .add-block-button(v-b-tooltip.hover.right="'Crear bloque'", @click="createBlock")
        square-icon
        plus-icon(style="width:15px;height:15px;position:absolute;top:50%;left:50%;background:white;")
      .flow-builder-controls-container
        .control(@click="resetPanzoomZoom", v-b-tooltip.hover.left="'Reiniciar posición'")
          crosshair-icon.icon-md
        .control(@click="panzoomZoom(false)", v-b-tooltip.hover.left="'Acercar'")
          plus-icon.icon-md
        .control(@click="panzoomZoom(true)", v-b-tooltip.hover.left="'Alejar'")
          minus-icon.icon-md
        .control(@click="arrangeBlocks", v-b-tooltip.hover.left="'Alinear'")
          align-left-icon.icon-md
      .panzoom-container
        .panzoom
          .diagram
            block(v-for="(block, index) in blocks", :id="`block_${block.block_id}`", v-bind="block", :key="block.block_id", @dblclick:block="moveMapToBlock(`#block_${$event}`)", @click:edit="pushBlockToHash($event)")
            flow-preview(v-for="(flow, index) in externalFlows", :id="`flow_${flow.flow_id}`", v-bind="flow", :key="flow.flow_id", @dblclick:block="moveMapToElement(`#flow_${$event}`)")
      side-modal(v-model="editBlock", :width="500")
        block-editor(:block="block", :platform="platform", @delete="confirmDeleteBlock")
    b-popover(target="conectorModal", :show.sync="show_connection_modal", placement="top", boundary-padding="0")
      template(slot="title")
        .d-flex.align-items-center.justify-content-between
          p.mb-0 Opciones de conexión
          x-icon.icon-sm.pointer(@click="show_connection_modal = false")
      b-button.create-block-btn(variant="soft-primary", block, :disabled="block_loading", @click="createBlock")
        .d-flex.align-items-center
          div.mr-2(style="position:relative")
            square-icon
            plus-icon.btn-soft-primary.plus-bg-hover(style="width:15px;height:15px;position:absolute;top:50%;left:50%;")
          p.mb-0 Crear bloque
          b-spinner.ml-1(small, variant="primary", v-if="block_loading")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { EventBus } from '@/helpers/eventBus'
import Block from '@/components/templates/Block.vue'
import FlowPreview from '@/components/templates/FlowPreview.vue'
import PlatformsTabs from '@/components/PlatformsTabs.vue'
import _debounce from 'lodash.debounce'
import _defer from 'lodash.defer'
import { jsPlumb as JSPlumb } from 'jsplumb'
import dagre from 'dagre'
import blockHelpers from '@/helpers/block-helpers'
import treeselectOptions from '@/data/treeselect-options'
import connectorTypes from '@/data/connector-types'
import SideModal from '@/components/SideModal.vue'

const accountController = createNamespacedHelpers('account')
const flowController = createNamespacedHelpers('flow')
const blockController = createNamespacedHelpers('block')
const BlockEditor = () => import('@/views/account/BlockEditor.vue')

export default {
  mixins: [blockHelpers],
  data () {
    return {
      blocksReady: false,
      flow: null,
      treeselect_options: treeselectOptions,
      connectorTypes,
      editBlock: false,
      edit_block_id: null,
      dragZoomSetted: false,
      block: null,
      externalFlows: [],
      platform: 'all',
      show_connection_modal: false,
      block_loading: false,
    }
  },
  computed: {
    ...blockController.mapState({
      blocks: state => state.blocks,
      selected_block: state => state.selected_block
    }),
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'selectedLanguageName']),
    parsedBlocks () {
      return this.blocks.filter(b => Boolean(b.name)).map(b => {return {id: b.block_id, label: b.name}})
    },
    ...flowController.mapGetters(['recentFlows']),
  },
  methods: {
    ...mapActions([
      'flow/all',
      'flow/get',
      'flow/allQueue',
      'flow/showMany',
      'block/create',
      'block/get',
      'block/destroy',
      'block/setStateBlocks',
      'template_connector/update',
      'block/getElementConnector',
      'block/getTemplateConnector',
      'element_connector/update',
      'template_connector/update',
      'platform/all'
    ]),
    getFlow () {
      let self = this
      this.showLoadingScreen()

      this['flow/get']({
        account_id: self.$route.params.account_id,
        flow_id: self.$route.params.flow_id,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.flow = res.resource
            let index = self.recentFlows.findIndex(f => f.flow_id ==  res.resource.flow_id)
            if (index < 0) {
              self.$store.commit('flow/setRecentFlows', res.resource)
            }
            self.getFlowBlocks()
          }
        }
      })
    },
    getFlowsData (array, justReturn = false) {
      let self = this
      if (!justReturn) self.externalFlows = []

      return new Promise(resolve => {
        this['flow/showMany']({
          account_id: self.$route.params.account_id,
          params: {
            flow_ids: array.join(','),
          },
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              if (justReturn) {
                return resolve(res.resource)
              } else {
                self.externalFlows = res.resource.slice()
              }
            }

            return resolve()
          }
        })
      })
    },
    getFlowBlocks () {
      this.showLoadingScreen()
      let self = this
      let blocksRequests = []

      for (let block of this.flow.Blocks) {
        blocksRequests.push(this.getBlock(block.block_id))
      }

      Promise.all(blocksRequests).then(results => {
        this['block/setStateBlocks']( results.filter(b => !b.error) )

        this.$nextTick(() => {
          // create external flows previews
          this.extractExternalFlows(() => {
            this.$nextTick(() => {
              this.resetJsPlumb()
              this.$nextTick(() => {
                this.drawBlocksInMap({
                  arrange: true,
                  repaint: true,
                  callback: () => {
                    self.hideLoadingScreen()
                    this.$nextTick(() => {
                      this.parseHash()
                    })
                  }
                })
              })
            })
          })
        })
      })
    },
    async extractExternalFlows (callback) {
      let self = this
      let availableTemplates = ['text', 'image', 'go_to', 'action_find_product', 'action_update_delivery', 'analyze_text', 'input_text', 'input_validation', 'action_edit_order', 'view', 'gallery', 'ai_nlp', 'validate', 'show_categories', 'compare', 'create_case']
      let availableConnectors = ['quick_reply', 'payload', 'go_to']

      let flowsIds = []
      let currentFlowId = this.$route.params.flow_id

      for (let block of self.blocks) {

        for (let template of block.Templates) {
          if (!availableTemplates.includes(template.type)) continue
          for (let template_connector of template.Template_Connectors) {

            let showQuickReplies = self.isLastShowableQuickReplies(block, template.template_id)

            // skip other connectors for the moment
            if ( !availableConnectors.includes(template_connector.type) && !this.connectorTypes.map(c => c.type).includes(template_connector.type) ) {
              continue
            }

            // skip hidden quick replies
            if (!showQuickReplies && template_connector.type == 'quick_reply') {
              continue
            }

            if (template_connector.next_block_id && (template_connector.next_block_id != block.block_id)) {
              // add to array external flow id
              if (template_connector.Block && template_connector.Block.flow_id != currentFlowId) {
                flowsIds.push(template_connector.Block.flow_id)
              }
            }
          }

          for (let element of template.Elements) {
            for (let element_connector of element.Element_Connectors) {
              if ( !availableConnectors.includes(element_connector.type) && !this.connectorTypes.map(c => c.type).includes(element_connector.type) ) {
                continue
              }

              if (element_connector.next_block_id && (element_connector.next_block_id != block.block_id)) {
                if (element_connector.Block && element_connector.Block.flow_id != currentFlowId) {
                  flowsIds.push(element_connector.Block.flow_id)
                }
              }
            }
          }
        }
      }

      if (flowsIds.length)
        await this.getFlowsData(flowsIds)

      if (callback) callback()
    },
    getBlock (block_id) {
      let self = this

      return new Promise((resolve, reject) => {
        this['block/get']({
          account_id: self.$route.params.account_id,
          block_id: block_id,
          params: {
            platform: self.platform,
            language_id: self.selectedLanguage
          },
          callback: res => {
            if (res.error) {
              resolve({ error: res.error })
            } else {
              resolve(res.resource)
            }
          }
        })
      })
    },
    setJsPlumb (callback) {
      let self = this

      if (!this.plumb) {
        this.plumb = jsPlumb.getInstance({
          Container: self.$diagram
        });

        this.plumb.importDefaults({
          Connector: [ "Bezier", { curviness: 150 } ],
          Endpoint: ['Dot', {
            radius: 8
          }],
          ConnectionOverlays: [
            [ 'PlainArrow', { width: 10, length: 7, location: 1 }]
          ],
          MaxConnections: -1
        });

        this.plumb.registerConnectionType("cluster", {
          cssClass: 'cluster-connector'
        });

        this.plumb.registerEndpointType("cluster", {
          cssClass: 'cluster-endpoint'
        });
      }

      if (callback) callback(true)
    },
    resetJsPlumb () {
      if (this.plumb) {
        this.plumb.reset()
      }
    },
    drawBlocksInMap (options) {
      if (!this.plumb) {
        if (options.callback) options.callback(false)
        return
      }

      if (!this.blocks.length) {
        this.$message.info('Este flujo no tiene bloques')
        if (options.callback) options.callback(false)
        return
      }

      let self = this,
          timeoutToTryAgain = 2000

      if (!this.loading_screen) this.showLoadingScreen()

      let availableTemplates = ['text', 'image', 'go_to', 'action_find_product', 'action_update_delivery', 'analyze_text', 'input_text', 'input_validation', 'action_edit_order', 'view', 'gallery', 'ai_nlp', 'validate', 'show_categories', 'compare', 'create_case']
      let availableConnectors = ['quick_reply', 'payload', 'go_to']

      for (let flow of self.externalFlows) {
        if (!document.getElementById(`flow_${flow.flow_id}`)) {
          console.log(`no flow_${flow.flow_id}`);
          setTimeout(() => {
            this.drawBlocksInMap.apply(this, arguments)
          }, timeoutToTryAgain);
          return
        }
      }

      // see if all blocks and connectors exists
      for (let block of self.blocks) {
        if (!document.getElementById(`block_${block.block_id}`)) {
          console.log(`no block_${block.block_id}`);
          setTimeout(() => {
            this.drawBlocksInMap.apply(this, arguments)
          }, timeoutToTryAgain);
          return
        }

        for (let template of block.Templates) {
          // skip other templates for the moment
          if (!availableTemplates.includes(template.type)) continue

          // retrieve all connectors in template
          for (let template_connector of template.Template_Connectors) {
            let showQuickReplies = self.isLastShowableQuickReplies(block, template.template_id)

            if (!document.getElementById(`template_connector_${template_connector.template_connector_id}`)) {
              // skip if is quick reply and can't show quick replies because is not last template
              if (template_connector.type == 'quick_reply' && !showQuickReplies) {
                continue
              } else if ( !availableConnectors.includes(template_connector.type) && !this.connectorTypes.map(c => c.type).includes(template_connector.type) ) {
                continue
              } else {
                console.log(`no template_connector_${template_connector.template_connector_id}`);
                /*
                setTimeout(() => {
                  this.drawBlocksInMap.apply(this, arguments)
                }, timeoutToTryAgain);
                */
                return
              }
            }
          }

          for (let element of template.Elements) {
            for (let element_connector of element.Element_Connectors) {
              if (!document.getElementById(`element_connector_${element_connector.element_connector_id}`)) {
                if ( !availableConnectors.includes(element_connector.type) && !this.connectorTypes.map(c => c.type).includes(element_connector.type) ) {
                  continue
                } else {
                  console.log(`no element_connector_${element_connector.element_connector_id}`);
                  setTimeout(() => {
                    this.drawBlocksInMap.apply(this, arguments)
                  }, timeoutToTryAgain);
                  return
                }
              }
            }
          }
        }
      }

      let connections = []

      // disable drawing for better performance
      this.plumb.setSuspendDrawing(true)

      for (let flow of self.externalFlows) {
        this.plumb.addEndpoint(`flow_${flow.flow_id}`, {
          isTarget: true,
          isSource: false,
          anchor: [ 0, 0, -3, 0, -1.5, 25 ],
          cssClass: 'hidden-endpoint',
          uuid: `flow_${flow.flow_id}`
        })
      }

      for (let block of self.blocks) {
        this.plumb.addEndpoint(`block_${block.block_id}`, {
          isTarget: true,
          isSource: false,
          anchor: [ 0, 0, -3, 0, -1.5, 25 ],
          cssClass: 'hidden-endpoint',
          uuid: `block_${block.block_id}`
        })

        this.plumb.makeTarget(`block_${block.block_id}`, {
          isTarget: true,
          anchor: [ 0, 0, -3, 0, -1.5, 25 ],
        })

        for (let template of block.Templates) {
          if (!availableTemplates.includes(template.type)) continue
          for (let template_connector of template.Template_Connectors) {

            let showQuickReplies = self.isLastShowableQuickReplies(block, template.template_id)

            // skip other connectors for the moment
            if ( !availableConnectors.includes(template_connector.type) && !this.connectorTypes.map(c => c.type).includes(template_connector.type) ) {
              continue
            }

            // skip hidden quick replies
            if (!showQuickReplies && template_connector.type == 'quick_reply') {
              continue
            }

            self.createEndpoint(`template_connector_${template_connector.template_connector_id}`)

            if (template_connector.next_block_id && (template_connector.next_block_id != block.block_id)) {
              if (template_connector.Block && template_connector.Block.flow_id != self.$route.params.flow_id) {
                connections.push({
                  uuids: [`template_connector_${template_connector.template_connector_id}`, `flow_${template_connector.Block.flow_id}`]
                })
              } else {
                connections.push({
                  uuids: [`template_connector_${template_connector.template_connector_id}`, `block_${template_connector.next_block_id}`]
                })
              }
            }
          }

          for (let element of template.Elements) {
            for (let element_connector of element.Element_Connectors) {
              if ( !availableConnectors.includes(element_connector.type) && !this.connectorTypes.map(c => c.type).includes(element_connector.type) ) {
                continue
              }

              self.createEndpoint(`element_connector_${element_connector.element_connector_id}`)

              if (element_connector.next_block_id && (element_connector.next_block_id != block.block_id)) {
                if (element_connector.Block && element_connector.Block.flow_id != self.$route.params.flow_id) {
                  connections.push({
                    uuids: [`element_connector_${element_connector.element_connector_id}`, `flow_${element_connector.Block.flow_id}`]
                  })
                } else {
                  connections.push({
                    uuids: [`element_connector_${element_connector.element_connector_id}`, `block_${element_connector.next_block_id}`]
                  })
                }
              }
            }
          }
        }
      }

      for (let connection of connections) {
        if (document.getElementById(connection.uuids[0]) && document.getElementById(connection.uuids[1])) {
          this.createConnection(
            {
              sourceId: connection.uuids[0],
              targetId: connection.uuids[1]
            },
            {
              detachable: true,
              reattach: false,
            },
            false
          )
        }
      }

      // draw all endpoints and connectors now
      this.plumb.setSuspendDrawing(false, true)

      this.plumb.bind('beforeDrop', (info) => {
        let block_id = this.getBlockIdFromElement(info.sourceId)
        let target = info.targetId.replace('block_', '')
        return block_id != target
      })

      this.plumb.bind('connection', (info) => {
        this.connectBlock(info.sourceId, info.targetId)
      })

      this.plumb.bind('connectionDetached', (info) => {
        this.connectBlock(info.sourceId, info.targetId, false)
      })

      this.plumb.bind('beforeDrag', (info) => {
        this.show_connection_modal = false
      })

      this.plumb.bind('connectionDragStop', (info) => {
        if (info.targetId.indexOf('block_') < 0) {
          let e = window.event
          let target = document.getElementById('conectorModal')
          target.style.setProperty('top', e.clientY + 'px')
          target.style.setProperty('left', e.clientX + 'px')
          this.show_connection_modal = true
        }
      })

      if (options.arrange) {
        this.arrangeBlocks()
      }

      if (!this.dragZoomSetted) {
        this.setPanzoom()
        this.dragZoomSetted = true
      }

      this.plumb.draggable($('.flow-builder-block'), {
                  stop: function(ev){
                    console.log('dragged: ', ev);
                  }
               })

      this.hideLoadingScreen()

      if (options.callback) options.callback(true)
    },
    isLastShowableQuickReplies (block, template_id) {
      for(var i = block.Templates.length - 1; i > -1; i--) {
        let template = block.Templates[i],
            type = template.type

        switch (type) {
          case 'gallery':
          case 'text':
          case 'image':
          case 'view':
          case 'random_text':
            return template.template_id == template_id
        }
      }

      return false
    },
    moveMapToBlock (block_id) {      
      this.$store.commit('block/setSelectedBlock', block_id.replace('#block_', ''))
      this.moveMapToElement(block_id)
    },
    moveMapToElement (block_id, template_id, element_id) {
      let self = this
      let block = $(block_id)
      let template = template_id ? $(template_id) : null
      let element = element_id ? $(element_id) : null

      if (this.$panzoom) {
        let zoomRatio = 0.8
        this.$panzoom.panzoom('zoom', zoomRatio)
        this.$panzoom.panzoom('pan', 0, 0)

        let blockLeft = block.position().left,
            blockHalfWidth = (block.width() / 2)

        if (element) {
          let elementLeft = element.position().left,
              elementHalfWidth = (element.width() / 2)

          blockLeft = blockLeft + elementLeft
        }

        let blockTop = block.position().top,
            blockHalfHeight = (block.height() / 2)

        if (template) {
          let templateTop = template.position().top,
              templateHalfHeight = (template.height() / 2)

          blockTop = blockTop + templateTop
        }

        let mapHalfWidth = 30 + (this.$panzoom.width() / 2)
        let mapHalfHeight = (this.$panzoom.height() / 2)

        // center with block max top below the toolbar
        blockHalfHeight = blockHalfHeight >= (mapHalfHeight - 50) ? (mapHalfHeight - 50) : blockHalfHeight

        let panX = (mapHalfWidth * zoomRatio) - blockLeft - blockHalfWidth
        let panY = (mapHalfHeight * zoomRatio) - blockTop - blockHalfHeight

        this.$panzoom.panzoom('pan', panX, panY)
      }
    },
    resetPanzoomZoom () {
      if (this.$panzoom) {
        this.$panzoom.panzoom("zoom", 0.5)
        this.$panzoom.panzoom('pan', 0, 0)
      }
    },
    panzoomZoom (zoomOut = true) {
      let self = this

      if (this.$panzoom) {
        this.$panzoom.panzoom("option", "increment", 0.2);
        this.$panzoom.panzoom('zoom', zoomOut, {
          animate: true,
          focal: {
            clientX: (self.$panzoom.parent().width() / 2),
            clientY: (self.$panzoom.parent().height() / 2)
          }
        })
        this.$panzoom.panzoom("option", "increment", 0.02);
      }
    },
    arrangeBlocks () {
      let self = this

      if (!this.loading_screen) this.showLoadingScreen()
      var dg = new dagre.graphlib.Graph();
      dg.setGraph({
        nodesep: 100,
        ranksep: 500,
        marginx: 100,
        marginy: 100,
        rankdir: 'LR',
        align: 'UL'
      });

      dg.setDefaultEdgeLabel(function() { return {}; })

      this.$container.find(".flow-builder-block").each(
        function(idx, node) {
          var $n = $(node);
          let maxWidth = Math.round($n.outerWidth())
          $n.find('.gallery-elements-row').each((i, el) => {
            let w = Math.round($n.outerWidth())
            $(el).find('.gallery-element').each((i, child) => {
              if (i > 0) {
                if (i == 1) {
                  w += (Math.round($(child).outerWidth()) + 16) * .7
                } else {
                  w += Math.round($(child).outerWidth()) + 16
                }
              }
            })

            if (w > maxWidth) {
              maxWidth = w
            }
          })

          var box = {
            width  : maxWidth || Math.round($n.outerWidth()),
            height : Math.round($n.outerHeight())
          };
          dg.setNode($n.attr('id'), box);
        }
      );

      this.plumb.getAllConnections()
        .forEach(function(edge) {
          // set edge the block not just the connector
          dg.setEdge('block_' + self.getBlockIdFromElement(edge.source.id), edge.target.id);
        });

      dagre.layout(dg);

      var graphInfo = dg.graph();
      dg.nodes().forEach(
        function(n) {
          var node = dg.node(n);
          if (node) {
            var top = Math.round(node.y-node.height/2)+'px';
            var left = Math.round(node.x-node.width/2)+'px';
            $('#' + n).css({left:left,top:top});
          }
        });

      EventBus.$emit('jsplumb:repaint')

      this.hideLoadingScreen()
    },
    setPanzoom () {
      if (this.$panzoom) return

      let self = this
      var minScale = 0.01;
      var maxScale = 2;
      var incScale = 0.02;

      self.$panzoom = self.$container.find('.panzoom').panzoom({
        cursor: 'move',
        minScale: minScale,
        maxScale: maxScale,
        increment: incScale,
        easing: 'ease-in-out',
        rangeStep: incScale,
        duration: 0,
        ignoreChildrensEvents: true
      })

      self.$container.find('.panzoom')
        .on("panzoomchange", function (e, pz) {
          var pz = self.$container.find(".panzoom");
          var currentScale = pz.panzoom("getMatrix")[0];
          self.plumb.setZoom(currentScale)
        });

      self.$panzoom.parent()
      .on('mousewheel.focal', function( e ) {
        e.preventDefault();

        if (e.ctrlKey||e.originalEvent.ctrlKey) {
          var delta = e.delta || e.originalEvent.wheelDelta;
          var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
          self.$panzoom.panzoom('zoom', zoomOut, {
             exponential: false,
             focal: e
          });
        } else if(e.altKey||e.originalEvent.altKey || e.shiftKey||e.originalEvent.shiftKey ) {
          let deltaY = e.deltaY || e.originalEvent.wheelDeltaY || (-e.originalEvent.deltaY);
          let deltaX = e.deltaX || e.originalEvent.wheelDeltaX || (-e.originalEvent.deltaX);
          self.$panzoom.panzoom("pan", deltaY / 2, deltaX / 2,{
            exponential: false,
            relative: true
          });
        } else {
          let deltaY = e.deltaY || e.originalEvent.wheelDeltaY || (-e.originalEvent.deltaY);
          let deltaX = e.deltaX || e.originalEvent.wheelDeltaX || (-e.originalEvent.deltaX);
          self.$panzoom.panzoom("pan", deltaX / 2, deltaY / 2,{
            exponential: false,
            relative: true
          });
        }

        // var delta = e.delta || e.originalEvent.wheelDelta;
        // var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
        // self.$panzoom.panzoom('zoom', zoomOut, {
        //    exponential: false
        // });
      })
      .on("mousedown touchstart",function(ev){
        var matrix = self.$container.find(".panzoom").panzoom("getMatrix");
        var offsetX = matrix[4];
        var offsetY = matrix[5];
        var dragstart = {x:ev.pageX,y:ev.pageY,dx:offsetX,dy:offsetY};
        $(ev.target).css("cursor","move");
        $(this).data('dragstart', dragstart);
      })
      .on("mousemove touchmove", function(ev){        
        var dragstart = $(this).data('dragstart');
        if(dragstart)
        {
          var deltaX = dragstart.x-ev.pageX;
          var deltaY = dragstart.y-ev.pageY;
          var matrix = self.$container.find(".panzoom").panzoom("getMatrix");
          matrix[4] = parseInt(dragstart.dx)-deltaX;
          matrix[5] = parseInt(dragstart.dy)-deltaY;
          self.$container.find(".panzoom").panzoom("setMatrix",matrix);
        }
      })
      .on("mouseup touchend touchcancel", function(ev){        
        $(this).data('dragstart',null);
        $(ev.target).css("cursor","");
      })

      this.$panzoom.panzoom('zoom', 0.5)
    },
    connectBlock (sourceId, targetId, connect = true) {
      let isElement = sourceId.split('_')[0] == 'element'
      let data = {
        connector_id: parseInt(sourceId.split('_').slice(-1)[0]),
        block_id: parseInt(this.getBlockIdFromElement(sourceId)),
        template_id: parseInt(this.getTemplateIdFromElement(sourceId)),
        element_id: parseInt(this.getElementIdFromElement(sourceId))
      }

      let route = isElement ? 'block/getElementConnector' : 'block/getTemplateConnector'
      this[route]({
        ...data,
        callback: connector => {
          if (connector) {
            let connectorUpdate = JSON.parse(JSON.stringify(connector))
            if (connect) {
              connectorUpdate.next_block_id = targetId.replace('block_', '')
            } else {
              connectorUpdate.next_block_id = null
            }
            this.updateConnector(data.block_id, data.template_id, connectorUpdate, isElement)
          }
        }
      })
    },
    updateConnector (blockId, templateId, connector, element = false) {
      const self = this
      const route = element ? 'element_connector/update' : 'template_connector/update'

      this[route]({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: blockId,
        template_id: templateId,
        ...connector,
        callback: async (res) => {
          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res === true) this.updateConnector.apply(this, arguments)
          }
        }
      })
    },
    hasHiddenConnectors (Elements) {
      if (!Array.isArray(Elements)) return false

      if (Elements.slice(1).length) {
        for (let element of Elements.slice(1)) {
          if (element.Element_Connectors.length) return true
        }
      }

      return false
    },
    parseHash () {
      if (this.$route.hash) {
        let hash = this.$route.hash.replace('#', '').split('&')
        for (let match of hash) {
          let param = match.split('=')
          if (param[0] == 'block_id' && param[1]) {
            this.edit_block_id = parseInt(param[1])
            this.moveMapToBlock(`#block_${param[1]}`)
            this.openBlockEditor()
            return true
          }
        }
      }

      return false
    },
    pushBlockToHash (block_id) {
      this.$router.push({hash: `block_id=${block_id}`}).catch(()=>{});
    },
    openBlockEditor (open = true) {
      this.$nextTick(() => {
        if (open) {
          this.$store.commit('block/setSelectedBlock', this.edit_block_id)
          this.editBlock = true
          this.block = this.blocks.find(b => b.block_id == this.edit_block_id) || null
        } else {
          this.editBlock = false
        }
      })
    },
    async createConnection (data, options = {}, fireEvent = false) {
      let self = this

      if ( (new RegExp(/^flow_/)).test(data.targetId) && !document.getElementById(data.targetId) ) {
        let flowObject = await this.getFlowsData([ data.targetId.replace('flow_', '') ], true)
        this.externalFlows.push(flowObject[0])
        this.makeElementDraggable(flowObject[0].flow_id, true, () => {
          this.doCreateConnection.apply(this, arguments)
        })
      } else {
        this.doCreateConnection.apply(this, arguments)
      }
    },
    doCreateConnection (data, options = {}, fireEvent = false) {
      let connectionObject = this.plumb.connect({
        uuids: [data.sourceId, data.targetId],
        ...options
      }, {
        fireEvent: fireEvent
      })

      if (connectionObject && connectionObject.bind) {
        connectionObject.bind('click', function (connection) {
          self.animateConnection(connection.canvas)

          let template_id = self.getTemplateIdFromElement(connection.sourceId)
          let block_id = self.getBlockIdFromElement(connection.sourceId)
          let element_id = self.getElementIdFromElement(connection.sourceId)
          if (template_id && block_id) {
            self.moveMapToElement(`#block_${block_id}`, `#template_${template_id}`, element_id != 0 ? `#element_${element_id}` : null)
          }
        })
      }

      this.$nextTick(() => {
        EventBus.$emit('jsplumb:repaint')
      })
    },
    createEndpoint (endpoint_id, callback) {
      let self = this

      if (!document.getElementById(endpoint_id)) {
        // if isn't drawn yet, retry in 1s
        setTimeout(() => {
          this.createEndpoint.apply(this, arguments)
        }, 1000);

        return
      }

      let connectorEndpoint = this.plumb.addEndpoint(endpoint_id, {
        isSource: true,
        isTarget: false,
        uuid: endpoint_id,
        maxConnections: 1,
        anchor: [ 0.5, 0.5, 3.5, 0 ]
      })

      connectorEndpoint.bind("click", function (connector) {
        if (connector.isSource && connector.connections) {
          let connections = connector.connections
          if (connections.length == 1) {
            let conn1 = connections[0]
            self.animateConnection(connections[0].canvas)
            self.moveMapToBlock(`#${conn1.targetId}`)
          } /* implement other logic for more than one connection */
        }
      })

      if (callback) callback(connectorEndpoint)
    },
    animateConnection (canvas) {
      var p = $(canvas).find("path")
      var timeout = null
      p.css('stroke-dasharray', 20)
      p.css('animation', 'dash 7s linear')
      p.css('stroke', '#4a5dff')
      p.attr('path-animation', true)
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        p.css('stroke-dasharray', '')
        p.css('animation', '')
        p.css('stroke', '')
        p.attr('path-animation', false)
      }, 7000);
    },
    getPlatforms () {
      let self = this

      this['platform/all']({
        account_id: self.$route.params.account_id,
        params: { platform: 'all' },
        callback: res => {
          if (res.error) {
            this.$message.error(res.error)
          }
        }
      })
    },
    createBlock () {
      let pz = this.$panzoom
      this.block_loading = true
      let self = this

      this['block/create']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        flow_id: self.$route.params.flow_id,
        callback: async (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            let block = await this.getBlock(res.resource.block_id)
            self.block_loading = false
            self.show_connection_modal = false
            if (!block.error) {
              if (self.blocks.length) {
                block.isNew = true
                self.$store.commit('block/appendBlock', block)
                self.makeElementDraggable(block.block_id);
              } else {
                block.isNew = true
                self.$store.commit('block/appendBlock', block)
                this.drawBlocksInMap({
                  arrange: true,
                  repaint: true
                })
              }
            } else {
              self.$message.error('Error creando bloque')
            }
          }
        }
      })
    },
    makeElementDraggable (element_id, isFlow = false, callback) {
      let elementType = isFlow ? 'flow_' : 'block_'
      if (!document.getElementById(`${elementType}${element_id}`)) {
        setTimeout(() => {
          this.makeElementDraggable.apply(this, arguments)
        }, 1000);
        return
      } else {
        this.plumb.draggable(`${elementType}${element_id}`,{
                  stop: function(){
                    console.log('dragged ...');
                  }
               })

        this.plumb.addEndpoint(`${elementType}${element_id}`, {
          isTarget: true,
          isSource: false,
          anchor: [ 0, 0, -3, 0, -1.5, 25 ],
          cssClass: 'hidden-endpoint',
          uuid: `${elementType}${element_id}`
        })

        this.plumb.makeTarget(`${elementType}${element_id}`, {
          isTarget: true,
          anchor: [ 0, 0, -3, 0, -1.5, 25 ],
        })

        // center on window
        let matrix = this.$panzoom.panzoom('getMatrix')
        $(`#${elementType}${element_id}`).css({
          left: (( parseFloat(matrix[4]) < 0 ? ( parseFloat(matrix[4]) * -1) : parseFloat(matrix[4]) ) + 100) / parseFloat(matrix[0]),
          top: (( parseFloat(matrix[5]) < 0 ? ( parseFloat(matrix[5]) * -1) : parseFloat(matrix[5]) ) + 100) / parseFloat(matrix[0])
        });
      }

      if (callback) callback()
    },
    async confirmDeleteBlock () {
      let res = await this.$bvModal.msgBoxConfirm('¿Deseas eliminar este bloque? No se puede deshacer.', {
        title: 'Borrar bloque',
        okVariant: 'danger',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar',
        hideHeaderClose: false
      })

      if (res == true) {
        this.deleteBlock()
      }
    },
    deleteBlock () {
      let self = this

      this['block/destroy']({
        account_id: self.$route.params.account_id,
        block_id: self.block.block_id,
        callback: async (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.editBlock = false
          }
        }
      })
    },
  },
  mounted () {
    this.getPlatforms()

    this.blocksReady = false
    this.jsPlumbReady = false
    this.plumb = null
    this.$container = $(".panzoom-container")
    this.$diagram = this.$container.find(".diagram")
    this.$panzoom = null

    jsPlumb.ready(() => {
      this.setJsPlumb(() => {
        this.getFlow()
      })
    });
    EventBus.$on('connection:changed', data => {
      let self = this

      if (data.type == 'detach') {
        this.plumb.getAllConnections().forEach(edge => {
          if (edge.sourceId == data.sourceId && edge.targetId == data.targetId) {
              this.plumb.deleteConnection(edge, {
                fireEvent: false
              })
          }
        })
      } else if (data.type == 'connect') {
        let source_block_id = self.getBlockIdFromElement(data.sourceId)
        if (`block_${source_block_id}` == data.targetId) return

        if (data.connector && data.connector.Block) {
          if (data.connector.Block.flow_id != this.$route.params.flow_id) {
            data.targetId = `flow_${data.connector.Block.flow_id}`
            this.createConnection(data)
          } else {
            this.createConnection(data)
          }
        } else {
          this.createConnection(data)
        }
      }
    })

    EventBus.$on('jsplumb:repaint', (block_id) => {      
      if (this.plumb) {
        if (block_id) {
          this.plumb.revalidate(block_id)
        } else {
          this.plumb.repaintEverything()
        }
      }
    })

    EventBus.$on('jsplumb:createElementConnectorEndpoint', (connectors) => {
      let self = this

      for (let element_connector_id of connectors) {
        if (!this.plumb.isSource(`element_connector_${element_connector_id}`)) {
          console.log('not source:', `element_connector_${element_connector_id}`);

          this.createEndpoint(`element_connector_${element_connector_id}`)

          this.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint')
          })
        }
      }
    })

    EventBus.$on('jsplumb:createTemplateConnectorEndpoint', (connectors) => {
      let self = this

      for (let template_connector_id of connectors) {
        if (!this.plumb.isSource(`template_connector_${template_connector_id}`)) {
          this.createEndpoint(`template_connector_${template_connector_id}`)

          this.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint')
          })
        }
      }
    })

    EventBus.$on('jsplumb:create&ConnectTemplateConnectorEndpoint', (connectors) => {
      let self = this
      let done = 0

      for (let template_connector of connectors) {
        let template_connector_id = template_connector.template_connector_id

        if (!this.plumb.isSource(`template_connector_${template_connector_id}`)) {
          console.log('not source:', `template_connector_${template_connector_id}`);

          this.createEndpoint(`template_connector_${template_connector_id}`, endpoint => {
            let block_id = this.getBlockIdFromElement(`template_connector_${template_connector_id}`)
            if (template_connector.next_block_id && (template_connector.next_block_id != block_id)) {
              if (template_connector.Block && template_connector.Block.flow_id != this.$route.params.flow_id) {
                this.createConnection(
                  {
                    sourceId: `template_connector_${template_connector.template_connector_id}`,
                    targetId: `block_${template_connector.Block.flow_id}`
                  },
                  {
                    detachable: true,
                    reattach: false,
                  },
                  false
                )
              } else {
                this.createConnection(
                  {
                    sourceId: `template_connector_${template_connector.template_connector_id}`,
                    targetId: `block_${template_connector.next_block_id}`
                  },
                  {
                    detachable: true,
                    reattach: false,
                  },
                  false
                )
              }
            }
            done ++
          })
        }

        if (done >= connectors.length) {
          this.$nextTick(() => {
            EventBus.$emit('jsplumb:repaint')
          })
        }
      }
    })

    EventBus.$on('jsplumb:destroyEndpoint', (element_id) => {
      console.log('destroy', element_id);
      this.plumb.deleteConnectionsForElement(element_id, {
        fireEvent: false
      })
      this.plumb.removeAllEndpoints(element_id)
      this.plumb.remove(element_id)
    })

    EventBus.$on('connector:change', (data) => {
      if (this.plumb) {
        this.plumb.deleteConnectionsForElement(data.sourceId, {
          fireEvent: false
        })

        EventBus.$emit('connection:changed', {
          type: 'connect',
          sourceId: data.sourceId,
          targetId: data.targetId,
          connector: data.connector
        })

        // this.plumb.repaintEverything()
      }
    })
  },
  beforeDestroy () {
    this['block/setStateBlocks']( [] )
    this.$store.commit('block/setSelectedBlock', null)
    EventBus.$off('connection:changed')
    EventBus.$off('jsplumb:repaint')
    EventBus.$off('connector:change')
  },
  components: {
    Block,
    SideModal,
    BlockEditor,
    FlowPreview,
    PlatformsTabs
  },
  watch: {
    '$route' (newValue, oldValue) {
      if (newValue.params.flow_id != oldValue.params.flow_id) {
        this.flow = null
        this.externalFlows = []
        this['block/setStateBlocks']( [] )
        this.resetPanzoomZoom()
        this.resetJsPlumb()
        this.$nextTick(() => {
          this.getFlow()
        })
      } else {
        this.parseHash()
      }
    },
    editBlock (value) {
      if (value == false) {
        this.$router.push({hash: ''}).catch(()=>{});
        this.block = null

        this.$nextTick(() => {
          EventBus.$emit('jsplumb:repaint', `block_${this.edit_block_id}`)
        })
      }
    },
    platform () {
      this.getFlowBlocks()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .main-container {
    width: 100%;
    height: 100%;
  }

  .flow-builder-body {
    width: 100%;
    height: calc(100% - 42px);
    position: relative;

    * {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  .panzoom-container {
    background-color: white;
    color: #00BFFF;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: #f9fbfd;
    background-image: radial-gradient(hsla(209, 100%, 47%, 0.3) 5%, transparent 0);
    background-size: 30px 30px;
  }
  .panzoom {
    position: absolute;
    min-width: 100%;
    min-height: 100%;
    background: transparent;
  }
  .diagram {
    position: absolute;
  }

  .flow-builder-toolbar {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    z-index: 100;
    pointer-events: none;
  }

  .flow-builder-controls-container {
    position: absolute;
    height: 200px;
    top: calc(50% - 100px);
    right: 0;
    z-index: 100;
    display: flex;
    flex-flow:column;
    align-items: center;
    justify-content: center;

    .control {
      width: 40px;
      height: 40px;
      margin: 5px 0;
      background-color: white;
      color: $primary;
      border: 1px solid $primary;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  #conectorModal {
    position: absolute;
  }

  .create-block-btn:hover .plus-bg-hover{
    color: #212529;
    background-color: #b5bdff;
    border-color: #a8b2ff;
  }
</style>

<style lang="scss">
  @import '@/assets/colors.scss';
  $connector-width: 4px;
  $gray: #9fa8b5;
  $cluster-blue: #084ca5;

  .jtk-drag-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .jtk-connector path {
    stroke: $gray;
    stroke-width: $connector-width;
  }

  .cluster-connector path {
    stroke: $cluster-blue;
    stroke-width: $connector-width;
  }

  .jtk-endpoint	{
    z-index: 2;

    svg circle {
      stroke: $light-danger;
      fill: $light-danger;
    }

    &.jtk-endpoint-connected {
      svg circle {
        stroke: $gray;
        fill: $gray;
      }
    }
  }

  .jtk-endpoint.cluster-endpoint	{
    z-index: 2;

    svg circle {
      stroke: $cluster-blue;
      fill: $cluster-blue;
    }
  }

  .jtk-hover svg circle {
    stroke: $primary !important;
    fill: $primary !important;
  }

  .jtk-hover path {
    stroke: $primary;
    stroke-width: $connector-width;
    cursor: pointer;
  }

  .jtk-dragged {
    cursor: grabbing !important;
  }

  .hidden-endpoint {
    svg circle {
      stroke: transparent !important;
      fill: transparent !important;
    }
  }

  .jtk-endpoint-drop-allowed {
    svg circle {
      stroke: $success !important;
      fill: $success !important;
    }
  }

  .jtk-overlay {
    width: 250px;
    text-align: center;
    color: white;
    background: rgba(0,0,0,0.7);
    border-radius: 5px;
    padding: 5px 15px;
    z-index: 3;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 1000;
    }
  }

  .add-block-button {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: white;
    border: 1px solid $primary;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $primary;
    cursor: pointer;
  }
</style>
